// @ts-nocheck

import _ from 'lodash';

import { type BasketState } from '../../../states/basket';
import { type MMAPIResponseResult } from '../../../states/basket';

import basketRemoveCachedMMAPIResponseInfos from './basketRemoveCachedMMAPIResponseInfos';

const basketAddCachedMMAPIResponseInfos = (
  state: BasketState,
  action: {
    payload: {
      result: MMAPIResponseResult;
      outcomes?: Array<{ betId: number; outcomeId: number }>;
      matchId: number;
    };
  },
) => {
  const { matchId, outcomes, result } = action?.payload ?? {};

  if ((typeof matchId === 'number' || typeof matchId === 'string') && typeof result === 'object') {
    return {
      ...state,
      cachedMMAPIResponsesInfos: {
        ...state.cachedMMAPIResponsesInfos,
        [matchId]: {
          matchId,
          outcomes,
          result,
        },
      },
    };
  }

  return state;
};

const basketUpdateCachedMMAPIResponseInfos = (
  state: BasketState,
  action: {
    payload: {
      result: MMAPIResponseResult;
      outcomes?: Array<{ betId: number; outcomeId: number }>;
      matchId: number;
    };
  },
) => {
  const { matchId, result } = action.payload;

  if ((typeof matchId === 'number' || typeof matchId === 'string') && typeof result === 'object') {
    return {
      ...state,
      cachedMMAPIResponsesInfos: {
        ...state.cachedMMAPIResponsesInfos,
        [matchId]: {
          ...state.cachedMMAPIResponsesInfos[matchId],
          result,
        },
      },
    };
  }

  return state;
};

type ActionTypeA = {
  payload: {
    result: MMAPIResponseResult;
    outcomes?: Array<{ betId: number; outcomeId: number }>;
    matchId: number;
  };
};

type ActionTypeB = {
  payload: {
    matchId: number;
  };
};

const basketAlterCachedMMAPIResponseInfos = (state: BasketState, action: ActionTypeA & ActionTypeB) => {
  const { outcomes: actionPayloadOutcomes, matchId: actionPayloadMatchId } = action.payload ?? {};

  const { cachedMMAPIResponsesInfos } = state;

  const cachedMMAPIResponseInfos = cachedMMAPIResponsesInfos[actionPayloadMatchId];

  if (cachedMMAPIResponseInfos) {
    if (_.isEqual(cachedMMAPIResponseInfos.outcomes, actionPayloadOutcomes)) {
      return basketUpdateCachedMMAPIResponseInfos(state, action);
    }

    return basketAddCachedMMAPIResponseInfos(basketRemoveCachedMMAPIResponseInfos(state, action), action);
  }

  return basketAddCachedMMAPIResponseInfos(state, action);
};

export default basketAlterCachedMMAPIResponseInfos;
